import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPromptTextToImage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPromptTextToImage"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H5V15H7V19H7.58594L16 10.5859L19 13.5859V7H14V5H21V21Z" fill="currentColor"/><Path d="M11 6H9V5H7V10H8V12H4V10H5V5H3V6H1V3H11V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPromptTextToImage;
